// frontend_react/src/context/CompanyContext.jsx

import React, { createContext, useContext, useMemo } from "react";

import PropTypes from "prop-types";
import { useLogin } from "./LoginContext";

const CompanyContext = createContext(null);

export function CompanyProvider({ children }) {
  const {
    currentUser,
    user,
    isAuthenticated,
    companyUuid,
    companyName,
  } = useLogin();

  const authUser = currentUser || user;

  const role = authUser?.role ?? null;

  const value = useMemo(
    () => ({
      user: authUser,

      isAuthenticated,

      role,

      companyUuid,
      companyName,

      isSuperAdmin:
        role === "ROLE_SUPER_ADMIN" ||
        role === "super_admin",

      isAdmin:
        role === "ROLE_ADMIN" ||
        role === "admin",

      isCurrentCompany: (uuid) =>
        uuid === companyUuid,
    }),
    [
      authUser,
      isAuthenticated,
      role,
      companyUuid,
      companyName,
    ]
  );

  return (
    <CompanyContext.Provider value={value}>
      {children}
    </CompanyContext.Provider>
  );
}

CompanyProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useCompany() {
  const context = useContext(CompanyContext);

  if (!context) {
    throw new Error(
      "useCompany must be used within CompanyProvider"
    );
  }

  return context;
}